import Roles from '@/auth/roles';
import PlayerForm from './coach-form';
import PlayerList from './coach-list';
import PlayerHistoryFull from './coach-history/coach-history-full/coach-history-full';
import PlayerHistorySingle from './coach-history/coach-history-single/coach-history-single';
import PlayerShow from './coach-show';

const roles = Roles.values;

export default [
  {
    name: 'coachList',
    path: 'coach',
    component: PlayerList,
    meta: {
      auth: true,
      roles: [
        roles.owner.id,
        roles.activityViewer.id,
        roles.entityViewer.id,
        roles.entityEditor.id,
        roles.coachViewer.id,
        roles.coachEditor.id
      ]
    }
  },
  {
    name: 'coachNew',
    path: 'coach/new',
    component: PlayerForm,
    meta: {
      auth: true,
      roles: [
        roles.owner.id,
        roles.entityEditor.id,
        roles.coachEditor.id,
        roles.clubManager.id
      ]
    }
  },
  {
    name: 'coachEdit',
    path: 'coach/:id/edit',
    component: PlayerForm,
    props: true,
    meta: {
      auth: true,
      roles: [
        roles.owner.id,
        roles.entityEditor.id,
        roles.coachEditor.id,
        roles.clubManager.id
      ]
    }
  },
  {
    name: 'coachHistorySingle',
    path: 'coach/:id/history',
    component: PlayerHistorySingle,
    props: true,
    meta: {
      auth: true,
      roles: [roles.owner.id, roles.activityViewer.id]
    }
  },
  {
    name: 'coachHistoryFull',
    path: 'coach/history',
    component: PlayerHistoryFull,
    meta: {
      auth: true,
      roles: [roles.owner.id, roles.activityViewer.id]
    }
  },
  {
    name: 'coachShow',
    path: 'coach/:id',
    component: PlayerShow,
    props: true,
    meta: {
      auth: true,
      roles: [
        roles.owner.id,
        roles.activityViewer.id,
        roles.entityViewer.id,
        roles.entityEditor.id,
        roles.coachViewer.id,
        roles.coachEditor.id,
        roles.clubManager.id
      ]
    }
  }
];



// WEBPACK FOOTER //
// ./src/entities/coach/coach-routes.js